import { render } from "./processingcomponent.vue?vue&type=template&id=02dd6c66"
import script from "./processingcomponent.vue?vue&type=script&lang=js"
export * from "./processingcomponent.vue?vue&type=script&lang=js"

import exportComponent from "/home/julien/build/build/p2p-exchange/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__